import { render } from "./users-table.vue?vue&type=template&id=4bd96c8a&scoped=true&lang=pug"
import script from "./users-table.vue?vue&type=script&lang=js"
export * from "./users-table.vue?vue&type=script&lang=js"

import "./users-table.vue?vue&type=style&index=0&id=4bd96c8a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd96c8a"]])

export default __exports__